<template>
  <v-card :to="{ name: 'article_edit', params: { id: article.id } }" max-width="400">
    <v-img
      :src="cover"
      class="white--text align-end"
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      height="350px"
    >
      <v-card-title style="word-break: break-word" v-text="article.title"></v-card-title>
    </v-img>

    <v-card-actions>
      <v-card-text>{{ dateDisplay }}</v-card-text>
      <v-spacer></v-spacer>

      <v-rating
        small
        v-model="article.priority"
        background-color="grey"
        color="secondary"
        readonly
        length="4"
      ></v-rating>
      <v-btn icon :color="article.published ? 'secondary' : 'grey'">
        <v-icon>mdi-earth</v-icon>
      </v-btn>
      <v-btn icon :color="article.reviewed ? 'secondary' : 'grey'">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
const moment = require('moment')

export default {
  name: 'ArticleListItem',
  props: {
    article: { type: Object, default: () => {} },
  },
  data() {
    return {}
  },
  computed: {
    cover() {
      if (this.article.cover) {
        return this.article.cover.sizes['300']
      }
      return require('@/assets/images/img_404.png')
    },
    dateDisplay() {
      return moment(this.article.date).locale('ru').format('LL')
    },
    videoId() {
      if (!this.article.video.url) {
        return ''
      }
      let match = this.article.video.url.match(/v=([0-9a-z_-]{1,20})/i)
      return match ? match['1'] : ''
    },
  },
  watch: {
    'article.priority': function (val) {
      // this.updateArticle({priority: this.article.priority})
    },
  },
  methods: {
    updateArticle(data) {
      // console.log(data)
      this.axios({ url: `/v1/articles/${this.article.id}`, method: 'patch', data: data })
        .then((resp) => {
          this.$emit('updatedArticle', resp.data)
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>
